export default "__VITE_ASSET__03c65353__"